import React, { useState, useEffect, useMemo } from "react";
import {
  Alert,
  Button,
  Container,
  Card,
  Modal,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Table,
  Form,
  Col,
  Row,
  Badge,
  Dropdown,
  ButtonGroup,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import toastr from "toastr";
import { Link } from "react-router-dom";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarConfig from "../../../components/SidebarDashboard";
import CustomTable from "../../../components/CustomTable";

import {
  deleteWorkflow,
  getMonitor,
  saveDadoDeBaja,
} from "../../../redux/on&offBoarning/monitor/actions";


import messages from "../../../redux/messages";

import "../../../css/onboarding.css";
import WorkFlowEmployeesCopiaMasiva from "../../../components/OnBoarding_OffBoarding/WorkFlowEmployeesCopiaMasiva";
import {
  editTareaSeguimiento,
  getBloque,
} from "../../../redux/on&offBoarning/capacitacion/actions";
import CustomPagint from "../../../components/CustomPagint";
import LinkDescargaBoarding from "../../../components/OnBoarding_OffBoarding/LinkDescargaBoarding";
import { getUsers } from "../../../redux/on&offBoarning/auth/authactionsBoarning";

const MonitorOnOffBoarding = (props) => {
  const filters = [
    { id: "nombre_empleado", desc: "Nombre empleado" },
    { id: "codigo_empleado", desc: "Codigo empleado" },
    { id: "nombre_wf", desc: "Nombre WorkFlow" },
    { id: "descripcion_wf", desc: "Descripción WorkFlow" },
    { id: "empleado_zona", desc: "Zona" },
    { id: "empleado_empresa", desc: "Empresa", authorized_roles: ["administrador"] },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);
  const [editItem, setEditItem] = useState({});
  const [editItemCopia, setEditItemCopia] = useState({});
  const [editItemIndexCopia, setEditItemIndexCopia] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showModalEnlaceClima, setShowModalEnlaceClima] = useState(false);
  const [showModalEnlaceCopia, setShowModalEnlaceCopia] = useState(false);
  const [showModalView, setShowModalView] = useState(false);
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [valorSeleccionado, setValorSeleccionado] = useState("");
  const [bloqueSeleccionado, setBloqueSeleccionado] = useState("");
  const [monitorNombre, setMonitorNombre] = useState("");
  const [view, setView] = useState("");
  const [buttonClicked, setButtonClicked] = useState(false);



  console.log(props)

  const dispatch = useDispatch();
  const history = useHistory();

  const userRoles = useSelector((store) => store.auth.userRoles);
  const userFilterRoles = useMemo(() => {
    return userRoles.filter(
      (usr) =>
        (usr === "Responsable_OffBoarding" && props.match.params.tipo === "2") ||
        (usr === "Responsable_OnBoarding" && props.match.params.tipo === "1") ||
        usr === "jefe" ||
        usr === "administrador" ||
        (usr === "Responsable_Headcount" && props.match.params.tipo === "2")
    );
  }, [userRoles, props.match.params.tipo]);

  const { monitor, monitorLength, loading, monitorError } = useSelector(
    (store) => store.monitorOnBoarding
  );
  const pages = Math.ceil(monitorLength / limit);

  const { username, name, unidName, users } = useSelector(
    (store) => store.authBoaring
  );
  const { capacitacion, loadingBloque, bloque, tareas } = useSelector(
    (store) => store.capacitacion
  );
  const capacitacionLoading = useSelector(
    (store) => store.capacitacion.loading
  );

  capacitacion &&
    capacitacion.workflow_bloques &&
    capacitacion.workflow_bloques.sort((a, b) => {
      return moment(a.fecha_fin) - moment(b.fecha_fin);
    });

  var userTemp = [];

  users.map((item) => {
    userTemp = [
      ...userTemp,
      {
        value: item.id,
        label: `${item.username} / ${item.first_name} ${item.last_name}`,
      },
    ];
  });

  const handleButtonClick = (item) => {
    onCrearCopia(item)
    setButtonClicked(true);
  };

  const columns = [
    {
      id: "countBlog",
      Header: "N°. tareas",
      Cell: (value) => (
        <Badge variant={value.row.original.num_bloques ? "info" : "warning"}>
          {value.row.original.num_bloques ? value.row.original.num_bloques : 0}
        </Badge>
      ),
    },
    {
      Header: "Workflow",
      accessor: "nombre",
    },
    {
      Header: "Codigo empleado",
      accessor: "empleado__username",
    },
    {
      id: "EmpleadoNombre",
      Header: "Empleado",
      accessor: "empleado__first_name",
      Cell: (value) => (
        <div className="d-flex justify-content-between">
          <p>
            {value.row.original.empleado__last_name
              ? `${value.row.original.empleado__first_name} ${value.row.original.empleado__last_name}`
              : value.row.original.empleado__first_name}
          </p>
        </div>
      ),
    },
    {
      Header: "Empresa",
      accessor: "empresa",
    },
    {
      Header: "Zona",
      accessor: "zona_c",
    },
    {
      Header: "Inicio",
      Filter: "",
      Cell: (value) =>
        moment(value.row.original.fecha_inicio).format("DD/MM/YYYY"),
    },
    {
      Header: "Fin",
      Filter: "",
      Cell: (value) => (
        <div
          style={{ width: "8.9rem" }}
          className={`rounded-pill text-white text-center px-2 ${moment(moment().format("YYYY-MM-DD")).diff(
            moment(value.row.original.fecha_fin),
            "days"
          ) > 0
              ? "bg-danger"
              : moment(value.row.original.fecha_fin).diff(
                moment(moment().format("YYYY-MM-DD")),
                "days"
              ) === 1
                ? "bg-info"
                : "bg-success"
            }`}
        >
          {moment(value.row.original.fecha_fin).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      Header: "Estado",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex justify-content-between">
          <div
            className={`rounded-pill ${value.row.original.estado ? "bg-success" : "bg-danger"
              }`}
            style={{ width: "3rem", height: "1rem", marginRight: ".6rem" }}
          ></div>
          <Form.Check disabled inline checked={value.row.original.estado} />
        </div>
      ),
    },
    {
      Header: "Dado de baja",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex justify-content-between">
          <div
            className={`rounded-pill ${value.row.original.col_dado_baja ? "bg-success" : "bg-danger"
              }`}
            style={{ width: "3rem", height: "1rem", marginRight: ".6rem" }}
          ></div>
          <Form.Check
            inline
            disabled={value.row.original.col_dado_baja || view === "jefe"}
            checked={value.row.original.col_dado_baja}
            value={value.row.original.id}
            onChange={handleCheckbox}
          />
        </div>
      ),
    },
    {
      id: "Porcentaje",
      Header: "% Avance",
      Cell: (value) => (
        <Badge variant="warning">
          {value.row.original.porcentaje
            ? Number(value.row.original.porcentaje)
            : Number(0)}
          %
        </Badge>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={
              <Tooltip {...props}>
                Visualizar descripción del seguimiento
              </Tooltip>
            }
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              className="text-dark btn rounded-pill mr-1"
              onClick={() =>
                onVerDescripcionWorkFlow(value.row.original, value.row.index)
              }
            >
              <i className="material-icons">visibility</i>
            </Button>
          </OverlayTrigger>
          {
            // (userRoles.includes("Responsable_OnBoarding") ||
            //   userRoles.includes("administrador") ||
            //   userRoles.includes("Responsable_OffBoarding")) &&
            (view === "Responsable_OnBoarding" ||
              view === "administrador" ||
              view === "Responsable_OffBoarding") && (
              <OverlayTrigger
                placement="auto"
                overlay={
                  <Tooltip {...props}>Copiar workflow a otros usuarios</Tooltip>
                }
              >
                <Button
                  size="sm"
                  className="text-success"
                  variant="link"
                  type="button"
                  onClick={() => handleButtonClick(value.row.original)}
                >
                  <i className="material-icons">group_add</i>
                </Button>
              </OverlayTrigger>
            )
          }
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>WorkFlow Tareas</Tooltip>}
          >
            <Link
              to={`/workflow-block/${value.row.original.id}/${value.row.original.nombre}/2`}
              className="btn btn-default btn-sm"
            >
              <i className="material-icons">grid_view</i>
            </Link>
          </OverlayTrigger>
          <LinkDescargaBoarding
            id={value.row.original.id}
            nombre={value.row.original.nombre}
          />
          {
            // (userRoles.includes("Responsable_OnBoarding") ||
            //   userRoles.includes("administrador") ||
            //   userRoles.includes("Responsable_OffBoarding"))
            (view === "Responsable_OnBoarding" ||
              view === "administrador" ||
              view === "Responsable_OffBoarding") && (
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Eliminar Workflow</Tooltip>}
              >
                <Button
                  size="sm"
                  className="text-danger"
                  variant="link"
                  type="button"
                  onClick={() =>
                    onDelete(value.row.original.id, value.row.index)
                  }
                >
                  <i className="material-icons">close</i>
                </Button>
              </OverlayTrigger>
            )
          }
        </div>
      ),
    },
  ];

  // Métodos
  const getWfRespMonitor = (
    offs = offset,
    lim = limit,
    filt = filter,
    viw = view
  ) =>
    dispatch(
      getMonitor(
        {
          offset: offs,
          limit: lim,
          filter: filt,
          tipo_busqueda: tipoBusqueda.id,
          tipo_workflow:
            parseInt(props.match.params.tipo) === 1 ? "[1]" : "[2,3]",
          vista: viw,
        },
        history
      )
    );

  useEffect(() => {
    dispatch(getUsers({}));
    if (userFilterRoles.length > 0) {
      const rolActual = userFilterRoles[0];
      setView(rolActual);
      getWfRespMonitor(offset, limit, filter, rolActual);
    }
  }, [props.match.params.tipo, userFilterRoles]);

  // useEffect(() => {
  //   dispatch(getUsers({}));
  //   if (view !== "") {
  //     getWfRespMonitor();
  //   }
  // }, [props.match.params.tipo, view]);

  useEffect(() => {
    switch (props.match.params.tipo) {
      case "1":
        history.push("/Monitor/OnBoarding/1");
        setMonitorNombre(props.match.params.nombre);
        break;
      case "2":
        history.push("/Monitor/OffBoarding/2");
        setMonitorNombre(props.match.params.nombre);
        break;
      default:
        history.goBack();
        break;
    }
  }, [props.match.params.nombre, props.match.params.tipo]);

  useEffect(() => {
    dispatch(getBloque({}, bloqueSeleccionado));
    setValorSeleccionado(bloqueSeleccionado);
  }, [bloqueSeleccionado]);

  const onCrearCopia = (item) => {
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onVerDescripcionWorkFlow = (item) => {
    setEditItem(item);
    setShowModalView(true);
    setValidated(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const req = {
      enlace_evaluacion: e.target.enlace.value,
      posicion: editItemCopia.posicion,
      bloque: editItemCopia.bloque,
    };

    dispatch(editTareaSeguimiento(editItemCopia.id, req, editItemIndexCopia));
    e.target.reset();
  };

  const onSearchRole = (e) => {
    e.preventDefault();
    setView(e.currentTarget.value);
    setFilter("");
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getWfRespMonitor(oOffset, limit, "", e.currentTarget.value);
  };

  const onSearch = (e) => {
    e.preventDefault();
    if (!e.target.filter.value.trim()) {
      return;
    }
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getWfRespMonitor(oOffset, limit, e.target.filter.value, view);
  };

  const seeAll = () => {
    const ofilter = "";
    setFilter(ofilter);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getWfRespMonitor(oOffset, limit, ofilter, view);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteWorkflow(id, index));
    }
  };

  const handleCheckbox = ({ target: { checked, value: checkValue } }) => {
    if (checked) {
      if (window.confirm("¿Esta seguro de dar de baja a esta persona?")) {
        if (window.confirm("Una vez dado de bajo no se podra editar.")) {
          dispatch(saveDadoDeBaja({ id: checkValue }, getWfRespMonitor));
        }
      }
    } else {
      toastr.info("No se pudo actualizar el estado");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid className="mt-4">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            {/* <Row className="mx-2 justify-content-end align-items-center flex-nowrap"> */}
            <h6 className="text-uppercase m-0 mr-3">
              <i
                className="flex-wrap material-icons mr-2"
                style={{ fontSize: "1.5rem", marginTop: "-.4rem" }}
              >
                computer
              </i>
              Monitor {monitorNombre}
            </h6>
            {/* {userRoles.filter(
                (usr) =>
                  (usr === "Responsable_OffBoarding" &&
                    props.match.params.tipo === "2") ||
                  (usr === "Responsable_OnBoarding" &&
                    props.match.params.tipo === "1") ||
                  usr === "jefe" ||
                  usr === "administrador" ||
                  (usr === "Responsable_Headcount" &&
                    props.match.params.tipo === "2")
              ).length > 1 ? (
                <>
                  <Col>
                    <h6>
                      <b>Ver como:</b>
                    </h6>
                  </Col>
                  <Col xs="auto">
                    <Form.Control
                      as="select"
                      name="filter"
                      id="filter"
                      placeholder="Buscar"
                      className="rounded-pill form-control-sm"
                      onChange={onSearchRole}
                      style={{ minWidth: "174px" }}
                    >
                      {userRoles
                        .filter(
                          (usr) =>
                            (usr === "Responsable_OffBoarding" &&
                              props.match.params.tipo === "2") ||
                            (usr === "Responsable_OnBoarding" &&
                              props.match.params.tipo === "1") ||
                            usr === "jefe" ||
                            usr === "administrador" ||
                            (usr === "Responsable_Headcount" &&
                              props.match.params.tipo === "2")
                        )
                        .map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                    </Form.Control>
                  </Col>
                </>
              ) : null} */}
            {/* </Row> */}
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <OverlayTrigger
                      placement="auto"
                      overlay={<Tooltip {...props}>Mostrar todos</Tooltip>}
                    >
                      <Button
                        onClick={() => seeAll()}
                        variant="light"
                        size="sm"
                        className="rounded-circle"
                      >
                        <i className="material-icons">list</i>
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => {
                            const tieneAcceso = !item.authorized_roles || item.authorized_roles.some(rol => userRoles.includes(rol));

                            return tieneAcceso ? (
                              <Dropdown.Item
                                onClick={() => setTipoBusqueda(item)}
                                key={item.id}
                              >
                                {item.desc}
                              </Dropdown.Item>
                            ) : null;
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          <Row className="mx-2 justify-content-start align-items-center flex-nowrap">
            {userRoles.filter(
              (usr) =>
                (usr === "Responsable_OffBoarding" &&
                  props.match.params.tipo === "2") ||
                (usr === "Responsable_OnBoarding" &&
                  props.match.params.tipo === "1") ||
                usr === "jefe" ||
                usr === "administrador" ||
                (usr === "Responsable_Headcount" &&
                  props.match.params.tipo === "2")
            ).length > 1 ? (
              <>
                <Col xs="auto">
                  <h6>
                    <b>Ver como:</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  {/* loadingAuth, users */}
                  <Form.Control
                    as="select"
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    onChange={onSearchRole}
                    style={{ minWidth: "174px" }}
                  >
                    {userFilterRoles.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </Form.Control>
                </Col>
              </>
            ) : null}
          </Row>
          <div className="px-3">
            <hr />
          </div>
          <div
            className="d-flex flex-column flex-nowrap"
            style={{ padding: "0 2.5rem" }}
          >
            <Row>
              <Col md={10}>
                <h6 className="mr-3 mb-3 text-uppercase text-muted">
                  {
                    // userRoles.includes("Responsable_OnBoarding") ||
                    // userRoles.includes("administrador") ||
                    // userRoles.includes("Responsable_OffBoarding")
                    view === "Responsable_OnBoarding" ||
                      view === "administrador" ||
                      view === "Responsable_OffBoarding"
                      ? "Persona responsable"
                      : "Persona"
                  }
                  :{" "}
                  <span className="bg-info p-1 rounded-pill text-white">
                    {username}-{name}
                  </span>
                </h6>
                <h6 className="text-uppercase text-muted">
                  Unidad:{" "}
                  <span className="bg-info p-1 rounded-pill text-white">
                    {unidName}
                  </span>
                </h6>
              </Col>
              <Col md={2}>
                <Button
                  variant="primary"
                  className="rounded-pill"
                  onClick={() =>
                    history.push(
                      `/monitorBording/taksListBording/${props.match.params.tipo}`
                    )
                  }
                >
                  <i className="material-icons">shortcut</i> Ir a tareas
                </Button>{" "}
              </Col>
            </Row>
          </div>
          {!!monitorError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {monitorError && monitorError.mensaje
                ? monitorError.mensaje
                : monitorError}
            </Alert>
          )}
          {loading ? (
            <div className="d-flex justify-content-center my-4 ml-3 mr-3">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : monitor && monitor.length === 0 && monitorError === "" ? (
            <Alert
              variant="info"
              className="my-4 ml-3 mr-3 d-flex flex-wrap justify-content-start align-items-center"
            >
              <i className="material-icons mx-3">info</i>
              No tiene seguimiento asignados, para mas información contactar al
              administrador.
            </Alert>
          ) : monitor && monitor.length > 0 ? (
            <>
              <Card className="border-0 px-2 py-3 px-sm-2">
                <Card.Body className="px-2 px-sm-2">
                  <CustomTable columns={columns} data={monitor} />
                  <CustomPagint
                    limit={limit}
                    setLimit={setLimit}
                    offset={offset}
                    setOffset={setOffset}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    dataLenght={monitorLength}
                    pages={pages}
                    pagFunc={getWfRespMonitor}
                  />
                </Card.Body>
              </Card>
            </>
          ) : null}
        </Container>
      </div>
      <WorkFlowEmployeesCopiaMasiva
        tipo_workflow={
          props.match.params.tipo && props.match.params.tipo !== ""
            ? parseInt(props.match.params.tipo)
            : 0
        }
        offset={offset}
        limit={limit}
        filter={filter}
        tipo_busqueda={tipoBusqueda}
        item={editItem}
        show={showModal}
        handleClose={() => setShowModal(false)}
        buttonClicked={buttonClicked}
      />
      <Modal
        size="lg"
        show={showModalView}
        onHide={() => setShowModalView(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="font-weight-bold text-uppercase m-0">
              <i
                className="flex-wrap material-icons"
                style={{ fontSize: "2rem", marginTop: "-.5rem" }}
              >
                assignment_ind
              </i>
              &nbsp;Descripción Completa del Seguimiento
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table
            striped
            bordered
            className="shadow-sm"
            style={{ border: "1px solid #ced4da" }}
          >
            <tbody>
              <tr>
                <td style={{ width: "35%" }}>
                  <b>Nombre:</b>
                </td>
                <td>{editItem ? editItem.nombre : null}</td>
              </tr>
              <tr>
                <td style={{ width: "35%" }}>
                  <b>Descripcion:</b>
                </td>
                <td>{editItem ? editItem.descripcion : null}</td>
              </tr>
              <tr>
                <td style={{ width: "35%" }}>
                  <b>Estado:</b>
                </td>
                <td>
                  {editItem
                    ? editItem.estado
                      ? "Completado"
                      : "Pendiente"
                    : null}
                </td>
              </tr>
              <tr>
                <td style={{ width: "35%" }}>
                  <b>Fecha Inicio:</b>
                </td>
                <td>{editItem ? editItem.fecha_inicio : null}</td>
              </tr>
              <tr>
                <td style={{ width: "35%" }}>
                  <b>Fecha Fin:</b>
                </td>
                <td>{editItem ? editItem.fecha_fin : null}</td>
              </tr>
              <tr>
                <td style={{ width: "35%" }}>
                  <b>Codigo empleado:</b>
                </td>
                <td>{editItem ? editItem.empleado__username : null}</td>
              </tr>
              <tr>
                <td style={{ width: "35%" }}>
                  <b>Nombre empleado:</b>
                </td>
                <td>
                  {editItem
                    ? `${editItem.empleado__first_name} ${editItem.empleado__last_name}`
                    : null}
                </td>
              </tr>
              <tr>
                <td style={{ width: "35%" }}>
                  <b>Finalizado:</b>
                </td>
                <td>{Number(editItem.num_ok)}</td>
              </tr>
              <tr>
                <td style={{ width: "35%" }}>
                  <b>Total actividades:</b>
                </td>
                <td>{Number(editItem.num_fail)}</td>
              </tr>
              <tr>
                <td style={{ width: "35%" }}>
                  <b>Porcentaje de avance:</b>
                </td>
                <td>{Number(editItem.porcentaje)}%</td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
      {/* <CompanionGuide
        show={showCompGuide}
        item={editItem}
        handleClose={() => setShowCompGuide(false)}
      /> */}
      <Modal
        size="lg"
        show={showModalEnlaceClima}
        onHide={() => setShowModalEnlaceClima(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="font-weight-bold text-uppercase m-0">
              <i
                className="flex-wrap material-icons"
                style={{ fontSize: "2rem", marginTop: "-.5rem" }}
              >
                cloud
              </i>
              &nbsp;Enlace Clima
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Col} controlId="bloque" className="mb-3">
            <Form.Label className="pl-0" column sm="12" md="2">
              <h5 className="m-0 d-flex">
                <i className="material-icons mr-1">grid_view</i>
                <b>Bloque:</b>
              </h5>
            </Form.Label>
            <Col className="pl-0" sm="12" md="4">
              <Form.Control
                as="select"
                id="bloque"
                name="bloque"
                className="rounded-pill shadow-sm"
                placeholder="bloque"
                value={valorSeleccionado}
                onChange={(e) => setBloqueSeleccionado(e.currentTarget.value)}
              >
                <option value="" selected disabled>
                  Seleccione un bloque
                </option>
                {capacitacion && capacitacion.workflow_bloques
                  ? capacitacion.workflow_bloques
                    .sort((a, b) => {
                      if (a.nombre && b.nombre) {
                        if (
                          a.nombre.toLowerCase() === b.nombre.toLowerCase()
                        ) {
                          return 0;
                        }
                        if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
                          return -1;
                        }
                      }
                      return 1;
                    })
                    .map((item) => (
                      <option key={item.id} value={item.id ? item.id : ""}>
                        {item.nombre ? item.nombre.toUpperCase() : ""}
                      </option>
                    ))
                  : null}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Col>
            {capacitacionLoading && (
              <Col sm="2">
                <Spinner animation="border" size="sm" />
              </Col>
            )}
          </Form.Group>
          {loadingBloque ? (
            <div className="d-flex justify-content-center mt-4">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : bloque && tareas && tareas.length > 0 ? (
            <>
              <div class="table-responsive">
                <Table striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nombre</th>
                      <th>Enlace</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {tareas.map((item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.nombre}</td>
                        <td>{item.enlace_evaluacion}</td>
                        <td>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip {...props}>
                                Modificar Calificación
                              </Tooltip>
                            }
                          >
                            <Button
                              size="sm"
                              variant="link"
                              className="p-0 pl-2"
                              onClick={() => {
                                setEditItemCopia(item);
                                setEditItemIndexCopia(index);
                                setShowModalEnlaceCopia(true);
                              }}
                            >
                              <i className="material-icons">quiz</i>
                            </Button>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          ) : valorSeleccionado !== "" ? (
            <Alert
              variant="info"
              className="my-4 ml-3 mr-3 d-flex flex-wrap justify-content-start align-items-center"
            >
              <i className="material-icons mx-3">info</i>
              El bloque no tiene tareas asignadas, para mas información
              contactar al administrador.
            </Alert>
          ) : (
            <Alert
              variant="info"
              className="my-4 ml-3 mr-3 d-flex flex-wrap justify-content-start align-items-center"
            >
              <i className="material-icons mx-3">info</i>
              Seleccione un bloque para dar seguimiento a las tareas.
            </Alert>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        size="md"
        show={showModalEnlaceCopia}
        onHide={() => setShowModalEnlaceCopia(false)}
      >
        <Form onSubmit={handleSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h4 className="font-weight-bold text-uppercase m-0">
                <i
                  className="flex-wrap material-icons"
                  style={{ fontSize: "2rem", marginTop: "-.5rem" }}
                >
                  cloud
                </i>
                &nbsp;Enlace
              </h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="12" md="3">
                <b>Enlace:</b>
              </Form.Label>
              <Col>
                <Form.Control
                  name="enlace"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={
                    editItemCopia ? editItemCopia.enlace_evaluacion : null
                  }
                  placeholder="Enlace clima laboral"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button className="rounded-pill" variant="secondary">
              Cerrar
            </Button>
            <Button className="rounded-pill" variant="primary" type="submit">
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default MonitorOnOffBoarding;